import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { active: { type: Number, default: 0 } }

  connect() {
    this.showTab(this.activeValue)
  }

  switch(event) {
    const index = parseInt(event.currentTarget.dataset.tabIndex)
    this.showTab(index)
  }

  showTab(index) {
    this.tabTargets.forEach((tab, i) => {
      if (i === index) {
        tab.classList.add("text-indigo-600", "border-indigo-600")
        tab.classList.remove("text-gray-500", "border-transparent", "hover:text-gray-700", "hover:border-gray-300")
      } else {
        tab.classList.remove("text-indigo-600", "border-indigo-600")
        tab.classList.add("text-gray-500", "border-transparent", "hover:text-gray-700", "hover:border-gray-300")
      }
    })

    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("hidden", i !== index)
    })

    this.activeValue = index
  }
}
